<template>
<v-dialog
    v-model="dialog"
    fullscreen
>
    <v-card>

        <v-card-title
            style="padding-bottom: 0; margin-bottom: -35px;"
        >
            <v-text-field
                label="Search Emojis"
                placeholder="Search Emojis"
                v-model="full_text"
                clearable
                solo
                flat
                autofocus
                autocomplete="off"
                @keydown.enter="onClickFirstRow"
                v-on:input="update"
            >
                <v-icon
                    slot="prepend"
                    v-on:click="onClickDiscardChanges"
                >
                    mdi-arrow-left
                </v-icon>
            </v-text-field>
        </v-card-title>


        <v-card-text>

            <v-list
            >
                <v-list-item
                    v-for="(item, index) in results"
                    :key="index"
                    v-on:click="onClickItem(item)"
                >
                    <slot v-bind:item="item">
                        <v-list-item-icon 
                            style="font-size: 40px; margin-right: 15px; margin-left: -15px;"
                        >
                            {{item.value}}
                        </v-list-item-icon>
                        <v-list-item-content>{{item.text}}</v-list-item-content>
                    </slot>
                </v-list-item>
                
            </v-list>

        </v-card-text>

    </v-card>
</v-dialog>
</template>

<script>

export default {

    data() {
        return {
            dialog: false,
            full_text: null,
            params: {},

            old_dialog_guard: null,
            results: [],
        }
    },

    created () {
        this.$event_bus.$on('pick-emoji', this.showDialog);
    },

    beforeDestroy () {
        this.$event_bus.$off('pick-emoji', this.showDialog);
    },

    methods: {

        showDialog(params)
        {
            if ( document.activeElement != null && document.activeElement.blur != null )
                document.activeElement.blur();

            this.full_text = null;
            this.params = params;
            this.dialog = true;

            this.old_dialog_guard = this.$router.dialog_guard;
            this.$router.dialog_guard = this.dialogGuard;
            this.update();
        },

        closeDialog()
        {
            this.dialog = false;
            this.$router.dialog_guard = this.old_dialog_guard;
        },

        dialogGuard(to, from, next)
        {
            if ( this.dialog == false )
            {
                // slipup somehow
                this.$router.dialog_guard = this.old_dialog_guard;
                return;
            }
                
            this.$router.dialog_guard = this.old_dialog_guard;    
            this.dialog = false;
            next(false);
            return;
        },

        onClickDiscardChanges()
        {
            this.closeDialog();
        },

        onClickFirstRow()
        {
            if ( this.results.length == 0 ) 
                return;
                
            this.onClickItem(this.results[0]);
        },

        onClickItem(item)
        {
            this.addToRecent(item.value);
            this.closeDialog();
            this.params.after_pick_function(item.value);
        },

        getRecent()
        {
            let ret = localStorage.getItem('rc_recent_emojis');

            if ( ret == null ) 
                return [];

            try
            {
                ret = JSON.parse(ret);
                if ( !Array.isArray(ret) ) return [];
                return ret;
            }
            catch(e) { return []; }
        },

        addToRecent(value)
        {
            let new_recent = this.getRecent();
            new_recent.unshift(value);

            while ( new_recent.length > 100 ) 
            {
                new_recent = new_recent.pop();
            }

            localStorage.setItem('rc_recent_emojis', JSON.stringify(new_recent));
        },

        update() {
            let ret = [];
            let all = this.$rc.emojis();

            let recent = this.getRecent();

            // Recent...
            for ( let i = 0; i < recent.length; i++ )
            {
                if ( ret.length >= 100 ) break;

                let emoji = this.findEmojiByValue(recent[i]);
                if ( emoji == null ) continue;

                if ( this.full_text == null || this.full_text.trim().length == 0 || emoji.text.toLowerCase().includes(this.full_text.toLowerCase()) )
                {
                    ret = this.addEmoji(ret, emoji);
                }
            }
            
            // Everyone elese
            for ( let i = 0; i < all.length; i++ )
            {
                if ( ret.length >= 100 ) break;

                if ( this.full_text == null || this.full_text.trim().length == 0 || all[i].text.toLowerCase().includes(this.full_text.toLowerCase()) ) 
                {
                    ret = this.addEmoji(ret, all[i]);
                }
            }

            this.results = ret;
        },

        addEmoji(cur_results, emoji)
        {
            if ( cur_results == null ) cur_results = [];

            for ( let i = 0; i < cur_results.length; i++ )
            {
                if ( cur_results[i].value == emoji.value )
                    return cur_results;
            }

            cur_results.push(emoji);

            return cur_results;
        },

        findEmojiByValue(value)
        {
            let all = this.$rc.emojis();

            for ( let i = 0; i < all.length; i++ )
            {
                if ( all[i].value == value )
                    return all[i];
            }

            return null;
        },
    },

    
}
</script>

<style lang="scss" scoped>
</style>